import React, {
    Component
} from 'react';
import * as d3 from 'd3';

class LineBarGraph extends Component {
    constructor(props) {
        super(props);
        this.createGraph = this.createGraph.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if ((prevProps.data !== null && prevProps.userData !== null) || (this.state.data !== prevProps.data && prevProps.userData !== this.props.userData)) {
            this.removeGraph();
            this.createGraph();
        }
    }

    createGraph() {
        const svg = d3.select("." + this.props.name + " svg"),
            margin = {
                top: 20,
                right: 20,
                bottom: 20,
                left: 20
            },
            width = this.props.width - margin.left - margin.right,
            height = this.props.height - margin.top - margin.bottom,
            g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")")
            svg.attr("width", '100%')
            .attr("height", '100%')
            .attr('viewBox','0 0 ' + this.props.width +' '+ this.props.height)
            .attr('preserveAspectRatio','xMinYMin');
        // Scales
        const scaleY = d3.scaleLinear()
        .domain([12, 0])
        .range([height, 0]);

        const scaleYAxis = d3.scaleLinear()
        .domain([0, 12])
        .range([height, 0]);

        const scenarioScale = d3.scaleBand()
        .rangeRound([0, width])
        .paddingInner(0.1)
        .domain(["Innovation", "Burn out", "Visibility", "Software"]);

        // Axis
        const yAxis  = d3.axisLeft(scaleYAxis).ticks(5).tickSize(0);
        const xAxis = d3.axisBottom(scenarioScale).ticks(4).tickSize(0);

        g.append("g")
        .attr("transform", "translate(" + 0 + "," + 0 + ")")
        .attr("fill", "white")
        .call(yAxis);
        g.append("g")
        .attr("transform", "translate(" + 0 + "," + height + ")")
        .call(xAxis);

        // Bar Chart
        let bars = g.append("g");
        bars.selectAll("rect")
            .data(this.props.data)
            .enter()
            .append("rect")
            .attr("x", function(d,i) { return 25.5 + 66 * i; })
            .attr("y", function(d,i) { return height - scaleY(d); })
            .attr("width", 10)
            .attr("height", function(d,i) { return scaleY(d); })
            .style("fill", "#912424");
        // Line
        if (this.props.userData !== undefined) {
            const lineInterpolate = d3.line()
            .x(function(d, i) { return 30.5 + 66 * i; })
            .y(function(d, i) { return scaleYAxis(d); })
            .curve(d3.curveLinear);

            let line = g.append("g");

            line.selectAll('circle')
                .data(this.props.userData)
                .enter()
                .append("circle")
                .attr("cx", function(d,i) { return 30.5 + 66 * i; } )
                .attr("cy", function(d,i) { return scaleYAxis(d); })
                .attr("r", 5)
                .style("fill", "gold");
            line.append("path")
                .style("fill","none")
                .style("stroke", "gold")
                .style("stroke-width","4px")
                .attr("d", lineInterpolate(this.props.userData));
        }
        // Legend
        let legend = g.append("g");
        legend.append("rect")
            .attr("x", width - 182)
            .attr("y", 0)
            .attr("width", 10)
            .attr("height", 10)
            .style("fill", "gold");
        legend.append("text")
            .attr("x", width - 172)
            .attr("y", 10)
            .text(this.props.group);
        legend.append("rect")
            .attr("x", width - 182)
            .attr("y", 15)
            .attr("width", 10)
            .attr("height", 10)
            .style("fill", "#912424");
        legend.append("text")
            .attr("x", width - 172)
            .attr("y", 25)
            .text(this.props.group + "  (All)");
    }

    removeGraph() {
        var svg = d3.select("." + this.props.name + " svg"),
        g = svg.select("g");    
        g.remove();
    }

    render() {
        return ( 
            <div className = {this.props.name}>
                <svg width={this.props.width} height={this.props.height}> </svg> 
            </div>
        );
    }
}

export default LineBarGraph;


// WEBPACK FOOTER //
// ./src/components/linebargraph.js